import { TransactionEnvelope } from "@saberhq/solana-contrib";
import { getATAAddress, getOrCreateATA, TOKEN_PROGRAM_ID, } from "@saberhq/token-utils";
import { SystemProgram } from "@solana/web3.js";
import { findRedeemerKey } from "./pda";
export * from "./pda";
export class RedeemerWrapper {
    constructor(sdk, iouMint, redemptionMint, key, data) {
        this.sdk = sdk;
        this.iouMint = iouMint;
        this.redemptionMint = redemptionMint;
        this.key = key;
        this.data = data;
    }
    get program() {
        return this.sdk.programs.Redeemer;
    }
    static async load({ sdk, iouMint, redemptionMint, }) {
        const [redeemer] = await findRedeemerKey({ iouMint, redemptionMint });
        const program = sdk.programs.Redeemer;
        const data = await program.account.redeemer.fetch(redeemer);
        return new RedeemerWrapper(sdk, iouMint, redemptionMint, redeemer, data);
    }
    static async createRedeemer({ sdk, iouMint, redemptionMint, }) {
        const { provider } = sdk;
        const [redeemer, bump] = await findRedeemerKey({ iouMint, redemptionMint });
        const ata = await getOrCreateATA({
            provider,
            mint: redemptionMint,
            owner: redeemer,
        });
        return {
            bump,
            vaultTokenAccount: ata.address,
            tx: new TransactionEnvelope(sdk.provider, [
                ...(ata.instruction ? [ata.instruction] : []),
                sdk.programs.Redeemer.instruction.createRedeemer(bump, {
                    accounts: {
                        redeemer,
                        iouMint,
                        redemptionMint,
                        payer: provider.wallet.publicKey,
                        systemProgram: SystemProgram.programId,
                    },
                }),
            ]),
        };
    }
    /**
     * redeemTokensIx
     */
    async redeemTokensIx(args) {
        return this.program.instruction.redeemTokens(args.tokenAmount, {
            accounts: await this.getRedeemTokenAccounts(args),
        });
    }
    async redeemTokens(args) {
        return new TransactionEnvelope(this.sdk.provider, [
            await this.redeemTokensIx(args),
        ]);
    }
    async getVaultAddress() {
        return await getATAAddress({
            mint: this.redemptionMint,
            owner: this.key,
        });
    }
    async getRedeemTokenAccounts(args) {
        const { iouSource, redemptionDestination, sourceAuthority } = args;
        return {
            redeemer: this.key,
            iouMint: this.data.iouMint,
            redemptionMint: this.data.redemptionMint,
            redemptionVault: await getATAAddress({
                mint: this.data.redemptionMint,
                owner: this.key,
            }),
            tokenProgram: TOKEN_PROGRAM_ID,
            sourceAuthority,
            iouSource,
            redemptionDestination,
        };
    }
}
//# sourceMappingURL=index.js.map